"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCardPageSize = exports.getImageCardUrl = exports.getSurveyTitleDisplay = exports.getSurveyTypeDisplay = exports.CardHelper = void 0;
const adaptivecards_1 = require("adaptivecards");
const ImageCardUrl_1 = require("../constants/ImageCardUrl");
var CardHelper;
(function (CardHelper) {
    function newCard() {
        const card = new adaptivecards_1.AdaptiveCard();
        card.version = adaptivecards_1.Versions.v1_2;
        return card;
    }
    CardHelper.newCard = newCard;
    function create(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    obj, props) {
        const t = new obj();
        if (props) {
            Object.assign(t, props);
        }
        return t;
    }
    CardHelper.create = create;
    function dateReplacementString(date, format) {
        const value = getRFC3389Date(date);
        return `{{DATE(${value}${format ? `,${format}` : ""})}}`;
    }
    CardHelper.dateReplacementString = dateReplacementString;
    function timeReplacementString(date) {
        return `{{TIME(${getRFC3389Date(date)})}}`;
    }
    CardHelper.timeReplacementString = timeReplacementString;
    function dateTimeReplacementString(date, format) {
        return `${dateReplacementString(date, format)} ${timeReplacementString(date)}`;
    }
    CardHelper.dateTimeReplacementString = dateTimeReplacementString;
    function toAttachment(card) {
        return {
            contentType: "application/vnd.microsoft.card.adaptive",
            content: toJSONv12(card),
        };
    }
    CardHelper.toAttachment = toAttachment;
    function toJSONv12(card) {
        return card.toJSON(new adaptivecards_1.SerializationContext(adaptivecards_1.Versions.v1_2));
    }
    CardHelper.toJSONv12 = toJSONv12;
    function toJSONv12String(card) {
        return JSON.stringify(toJSONv12(card));
    }
    CardHelper.toJSONv12String = toJSONv12String;
    function getRFC3389Date(date) {
        function pad(num) {
            if (num < 10)
                return "0" + num;
            return num;
        }
        const value = date.getUTCFullYear() +
            "-" +
            pad(date.getUTCMonth() + 1) +
            "-" +
            pad(date.getUTCDate()) +
            "T" +
            pad(date.getUTCHours()) +
            ":" +
            pad(date.getUTCMinutes()) +
            ":" +
            pad(date.getUTCSeconds()) +
            "Z";
        return value;
    }
})(CardHelper = exports.CardHelper || (exports.CardHelper = {}));
const DEFAULT_SURVEY_DISPLAY_OPTIONS = {
    capitalize: false,
    plural: false,
};
const getSurveyTypeDisplay = (type, options) => {
    const { capitalize, plural } = Object.assign(Object.assign({}, DEFAULT_SURVEY_DISPLAY_OPTIONS), options);
    let display;
    switch (type) {
        case "survey":
        case "poll":
            display = capitalize ? "Polly" : "polly";
            break;
        case "quiz":
            display = capitalize ? "Quiz" : "quiz";
            break;
        case "agile-standup":
            display = capitalize ? "Standup" : "standup";
            break;
        case "trivia":
            display = capitalize ? "Trivia" : "trivia";
            break;
        case "qna":
            display = "Q&A";
            break;
        case "icebreaker":
            display = "Icebreaker";
            break;
        case "hot-take":
            display = "Hot Take";
            break;
        default:
            throw new Error(`unknown survey type ${type}`);
    }
    if (plural) {
        display = `${display}s`;
    }
    return display;
};
exports.getSurveyTypeDisplay = getSurveyTypeDisplay;
const getSurveyTitleDisplay = (survey) => {
    switch (survey.type) {
        case "agile-standup":
            return `${survey.title} standup for ${CardHelper.dateReplacementString(survey.deliverAt, "SHORT")}`;
        default:
            return survey.title;
    }
};
exports.getSurveyTitleDisplay = getSurveyTitleDisplay;
function getImageCardUrl(type, applicationType) {
    if (applicationType === "agile") {
        return ImageCardUrl_1.AgileImageCardUrl[type];
    }
    return ImageCardUrl_1.CoreImageCardUrl[type];
}
exports.getImageCardUrl = getImageCardUrl;
function getCardPageSize(survey) {
    // Bug in MS where meeting invoked task modules are persisting state.
    // Show all quiz questions for now so they don't get wrong answers selected by default.
    return survey.type === "quiz" ? 1 : 2;
}
exports.getCardPageSize = getCardPageSize;
//# sourceMappingURL=CardHelper.js.map